module.exports = __webpack_public_path__ + "img/loginBg.cb34d259.jpg";